import { useQuery } from "@tanstack/react-query";

import { cmmdApiClient } from "../../environments/cmmdApi";
import { parseCloudProjectLifecyclePreflight } from "./cloudProjectLifecyclePreflight";

/** Reads persisted CMMD evidence only. This never wakes or probes a Sprite. */
export function useCloudProjectLifecyclePreflight(projectId: number | null) {
  const query = useQuery({
    queryKey: ["cmmd", "cloud-project-lifecycle-preflight", projectId],
    queryFn: async () => {
      const receipt: unknown = await cmmdApiClient.getCloudProjectLifecyclePreflight(projectId!);
      return parseCloudProjectLifecyclePreflight(receipt, projectId!);
    },
    enabled: projectId !== null,
    staleTime: 15_000,
    retry: false,
  });

  return {
    receipt: query.data,
    error: query.error instanceof Error ? query.error.message : undefined,
    pending: projectId !== null && query.isPending,
  } as const;
}
